<template>
  <div>
    <!--Messages d'erreur-->
    <div class="alert alert-danger alert-dismissible fade show"
         :style="{ 'display': authError }" role="alert">
      Erreur de connexion
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible fade show" role="alert"
         :style="{ 'display': invalidCredentials }">
      Identifiants invalides
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible fade show" role="alert"
         :style="{ 'display': disabledUser }">
      La connexion a échouée, veuillez vérifier votre identifiant et votre mot de passe.
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="row justify-content-center">
      <form @submit="formSubmit" class="col-8">
        <div class="form-group">
          <label for="idInput" class="text-label">Identifiant</label>
          <input id="idInput" type="text" class="form-control" v-model="name"
                 :class="{ 'is-invalid': this.$v.name.$error }"
                 @input="$v.name.$touch()">
        </div>

        <div class="form-group">
          <!--<div class="error" v-if="!this.$v.name.required">Field is required</div>-->
          <label for="passwordInput" class="text-label">Mot de passe</label>
          <!--passwordType pour modifier l'affichage du champ-->
          <input id="passwordInput" :type="passwordType" class="form-control"
                 :class="{ 'is-invalid': this.$v.password.$error }"
                 @input="$v.password.$touch()"
                 v-model="password">
          <!--<div class="error" v-if="!this.$v.password.required">Field is required</div>-->
        </div>

        <div class="form-check">
          <input type="checkbox" class="form-check-input"
                 @click="switchVisibility" id="switchVisibility">
          <label class="form-check-label text-label" for="switchVisibility">
            Afficher le mot de passe
          </label>
        </div>

        <!--Bouton désactivé si le formulaire est invalide-->
        <button type="submit" class="btn btn-success btn-block btn-lg mt-3"
                :disabled="!this.$v.name.required || !this.$v.password.required">
          SE CONNECTER
        </button>
      </form>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import { required } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      passwordType: 'password',
      authError: 'none',
      invalidCredentials: 'none',
      disabledUser: 'none',
      name: '',
      password: '',
    };
  },
  methods: {
    // Afficher le mot de passe
    switchVisibility() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    // Gestion du post du formulaire d'auth
    formSubmit(e) {
      e.preventDefault();
      axios.post('/auth/api/auth', JSON.stringify({
        login: this.name,
        password: this.password,
      }), { headers: { 'content-type': 'application/json' } })
        .then((response) => {
          // this.$cookie.set('token', response.data.token, { expires: '2h' });
          axios.get(`/parametrage/api/urls/${response.data.data.storeId}`)
            .then((destination) => {
              let source;
              // let hash;
              if (this.$parent.path) {
                // add path if provided
              }
              if (this.$parent.source) {
                source = destination.data[this.$parent.source];
                if (source && source.includes(destination.data.Customers)) {
                  source = source.replace(destination.data.Customers, destination.data.CustomersIS);
                } else if (source && source.includes(destination.data.services)) {
                  source = source.replace(destination.data.services, destination.data.Services);
                }
                // hash = this.$parent.path && this.$parent.path !== '/' ? this.$parent.path : '';
              } else if (this.$parent.url) {
                source = this.$parent.url + this.$parent.hash;
              } else {
                this.$router.push({ name: 'Error', params: { errorType: 'source' } });
              }

              window.location.href = source;
            });
        })
        .catch((error) => {
          // affichage des alert d'erreur
          if (error.response.status === 401) {
            this.invalidCredentials = 'block';
          } else if (error.response.status === 403) {
            this.disabledUser = 'block';
          } else {
            this.authError = 'block';
          }
        });
    },
  },
  // Règles de validation du formulaire
  validations: {
    name: {
      required,
    },
    password: {
      required,
    },
  },
};
</script>
